import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';
import * as _ from 'lodash';

@Pipe({
  name: 'dateTimeSec'
})
export class DateTimeSecPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    if (_.isNil(value)) {
      return '';
    }
    value = value * 1000;
    return new DatePipe('en-US').transform(value, 'dd-MMM-yy HH:mm:ss');
  }

}
